import { render, staticRenderFns } from "./SideToolBar.vue?vue&type=template&id=3b6366bb&scoped=true&"
import script from "./SideToolBar.vue?vue&type=script&lang=js&"
export * from "./SideToolBar.vue?vue&type=script&lang=js&"
import style0 from "./SideToolBar.vue?vue&type=style&index=0&id=3b6366bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6366bb",
  null
  
)

export default component.exports